import getGTMDetails from '@/api/requests/checkout/getGTMDetails'
import Facebook from '@/services/Facebook'
import GTM from '@/services/GTM'
import { CartItem } from '@/ts/Cart'

async function handleGTMDetails(id: number) {
  const response = await getGTMDetails(id)

  if (response.status === 'success') {
    const products: CartItem[] =
      response.content?.ecommerce?.purchase?.products ?? []

    GTM.pushOrder(response.content)

    products.forEach(({ id, price }) => {
      if (Number(price) > 0) {
        Facebook.track('Purchase', {
          currency: 'PLN',
          value: Number(price),
          content_ids: [id],
        })
      }
    })
  }

  return
}

export default handleGTMDetails
